import { pluralize } from "constants/pluralize.js";
import { Axios } from "services/axios";

export const faqApi = {
  saveFaq: async (faqData) => {
    try {
      const response = await Axios.post('/faq/addFaq', faqData);
      return response.data?.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to save FAQ');
    }
  },

  assignFaqToPages: async (faqId, pageAssignments) => {
    try {
      const response = await Axios.post(`/faq/${faqId}/assign-pages`, {
        pageAssignments
      });
      return response.data?.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to assign FAQ to pages');
    }
  },

  getAllFaqs: async (page = 1, limit = 10, search = '', pageId = null) => {
    try {
      let url = `/faq/all?page=${page}&limit=${limit}`;
      if (search) url += `&search=${search}`;
      if (pageId) url += `&pageId=${pageId}`;

      const response = await Axios.fetch(url);
      return response.data?.data || { faqs: [], pagination: {} };
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch FAQs');
    }
  },

  getFaqAssignments: async (faqId) => {
    try {
      const response = await Axios.fetch(`/faq/${faqId}/assignments`);
      return response.data?.data || [];
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch FAQ assignments');
    }
  },

  deleteFaq: async (faqId) => {
    try {
      await Axios.delete(`/faq/faqById/${faqId}`);
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete FAQ');
    }
  },

  getEntities: async (entityType) => {
    try {
      const endpoint = pluralize(entityType);
      const response = await Axios.fetch(`/faq/entities/${endpoint}`);
      return response.data?.data || [];
    } catch (error) {
      throw new Error(error.response?.data?.message || `Failed to fetch ${entityType}s`);
    }
  }
};
